module.exports = __webpack_public_path__ + "img/transaction_type.966f9798.svg";